export const RESETSTATSLOG_LIST_REQUEST = 'RESETSTATSLOG_LIST_REQUEST';
